
import TableList from "@components/templates/tablelist";
import { HttpGetBillRehandleList } from "@/service/chargescalc";
import { HttpServiceWarehouseList } from "@/service/basicdata";
import { HttpGetOurWarehouseList } from '@/service/bespeak';
import { mapState, mapGetters } from "vuex";
import compIndex from './rehandleupdate'
export default {
    mixins: [TableList],
    components:{
        compIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            warehouseList: [],
        };
    },
    created() {
        HttpGetOurWarehouseList().then(res => {
            this.warehouseList = (res.data || []).map(item => {
                return {
                    value: item.id,
                    label: `${item.code}(${item.title})`
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    methods: {
        ajaxRequest: HttpGetBillRehandleList,

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.operate={
                        show: true,
                        title: "重处理",
                        width:500,
                        component: "compIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusBillTypeList','getUserManageWarehouseList'],),
        ToolsData(){
            return [
                {
                    name: "重处理",
                    operate: "add",
                    theme: "primary",
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [
                {
                    label: "仓库",
                    tag: "vSelect",
                    key: "EQ_orgWarehouseId",
                    options: this.warehouseList,
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label: "重处理编号",
                    tag: 'vInput',
                    key: 'EQ_reprocessNo',
                    show:true,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: '费用类型',
                    tag: 'vSelect',
                    key: 'EQ_expenseCategoryType',
                    options: [
                        { value: 0, label: '作业费' },
                        { value: 1, label: '仓储费' },
                        { value: 3, label: '增值服务费' },
                    ],
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '创建时间',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                }
            ]
        },
        columns() {
            return  [
                // {
                //     show:false,
                //     type: 'selection',
                //     width: 60,
                //     align: 'center',
                //     formName: 'id'
                // },
                // {
                //     title: '操作',
                //     width: 90,
                //     render:this.getOperateNodes,
                // },
                {
                    title: '重处理编号',
                    key:'reprocessNo'
                },
                {
                    title: '费用类型',
                    key: 'expenseCategoryType',
                    render: (h, { row }) => this.findRenderLabel(this.getCusBillTypeList, row.expenseCategoryType),
                },
                {
                    title: '账单编号',
                    key:'billNo'
                },
                {
                    title: "仓库",
                    render: (h, { row }) =>
                        this.findRenderLabel(this.warehouseList, row.warehouseId)||"--",
                },
                {
                    title: '结算账期',
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.startTime || '--'} ~ {row.endTime || '--'}</div>
                        </div>

                    },
                },
                {
                    title: '创建人',
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.createdName || '--'}</div>
                        </div>

                    },
                },
                {
                    title: '创建时间',
                    key:'createdAt'
                },
            ];
        },

    },

};
